import React from 'react';

function Header() {

    return (
        <>
            <header className="ontario-header" id="ontario-header">
                <div className="ontario-row">
                    <div
                        className="ontario-header__logo-container ontario-columns ontario-small-2 ontario-medium-4 ontario-large-3">
                        <a href="http://www.ontario.ca">
                            <img className="ontario-show-for-medium" src="/images/logos/ontario-logo--desktop.svg"
                                 alt="{{labels.imageAlt}}" width="180" height="46"/>
                            <img className=" ontario-show-for-small-only" src="/images/logos/ontario-logo--mobile.svg"
                                 alt="{{labels.imageAlt}}" width="45" height="46" />
                        </a>
                    </div>

                    <form
                        className="ontario-header__search-container ontario-columns ontario-small-10 ontario-medium-offset-2 ontario-medium-8 ontario-large-offset-0 ontario-large-6"
                        id="ontario-search-form-container">
                        <label htmlFor="ontario-search-input-field" className="ontario-show-for-sr">Search</label>
                        <input
                            type="text"
                            name="search"
                            id="ontario-search-input-field"
                            autoComplete="off"
                            aria-autocomplete="none"
                            className="ontario-input ontario-header__search-input"
                            required="required"
                        />
                        <button className="ontario-header__search-clear-input ontario-header__search-clear-input--hide"
                                id="ontario-search-clear-input-field">
                            <span className="ontario-show-for-sr">Clear</span>
                            {/*<svg className="ontario-icon"*/}
                            {/*     focusable="false" sol:category="primary" viewBox="0 0 24 24"*/}
                            {/*     preserveAspectRatio="xMidYMid meet">*/}
                            {/*    <use xlink:href="#ontario-icon-close"></use>*/}
                            {/*</svg>*/}

                            <svg
                                className="ontario-icon"
                                viewBox="0 0 24 24"
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <path
                                    d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4z"
                                    fill=""
                                />
                                {/*<use xlinkHref="#ontario-icon-close" />*/}
                            </svg>

                        </button>
                        <button className="ontario-header__search-submit" type="submit">
                            <span className="ontario-show-for-sr">Search</span>
                            <svg
                                className="ontario-icon ontario-header__icon--medium"
                                viewBox="0 0 24 24"
                                preserveAspectRatio="xMidYMid meet"
                            >
                                {/*<use xlinkHref="#ontario-icon-search" />*/}
                                <path
                                    d="M15.5 14h-.8l-.28-.27A6.47 6.47 0 0016 9.5a6.5 6.5 0 10-13 0A6.5 6.5 0 009.5 16a6.47 6.47 0 004.23-1.57l.27.28v.8l5 5 1.5-1.5-5-5zm-6 0C7 14 5 12 5 9.5S7 5 9.5 5 14 7 14 9.5 12 14 9.5 14z"
                                    fill=""
                                />
                            </svg>
                        </button>
                    </form>
                    <div
                        className="ontario-header__nav-right-container ontario-columns ontario-small-10 ontario-medium-8 ontario-large-3">
                        <a href=""
                           className="ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline">
                            <span className="ontario-show-for-sr">
                                Click for swicth to language
                            </span>
                            <span className="ontario-show-for-small-only">
                               FR
                            </span>
                            <span className="ontario-show-for-medium">
                               French
                            </span>
                        </a>

                        <button
                            className="ontario-header__search-toggler ontario-header-button ontario-header-button--without-outline ontario-hide-for-large"
                            id="ontario-header-search-toggler" aria-controls="ontario-search-form-container">
                            {/*<svg className="ontario-icon"*/}
                            {/*     focusable="false" sol:category="primary" viewBox="0 0 24 24"*/}
                            {/*     preserveAspectRatio="xMidYMid meet">*/}
                            {/*    <use xlink:href="#ontario-icon-search"></use>*/}
                            {/*</svg>*/}
                            <svg className="ontario-icon"
                                 viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                {/*<use xlinkHref="#ontario-icon-search" />*/}
                                <path
                                    d="M15.5 14h-.8l-.28-.27A6.47 6.47 0 0016 9.5a6.5 6.5 0 10-13 0A6.5 6.5 0 009.5 16a6.47 6.47 0 004.23-1.57l.27.28v.8l5 5 1.5-1.5-5-5zm-6 0C7 14 5 12 5 9.5S7 5 9.5 5 14 7 14 9.5 12 14 9.5 14z"
                                    fill=""
                                />
                            </svg>
                            <span className="ontario-show-for-medium ontario-show">
                                Search
                             </span>
                        </button>

                        <button
                            className="ontario-header__menu-toggler ontario-header-button ontario-header-button--with-outline"
                            id="ontario-header-menu-toggler" aria-controls="ontario-header-navigation"
                            aria-label="{{labels.open}}">
                            <svg className="ontario-icon ontario-header__icon--medium ontario-margin-right-8-!"
                                 aria-label="open menu" viewBox="0 0 24 24"
                                 preserveAspectRatio="xMidYMid meet">
                                {/*<use xlinkHref="#ontario-icon-menu" />*/}
                                <path
                                    d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
                                    fill=""
                                />
                            </svg>
                            <span>Menu</span>
                        </button>
                    </div>
                    <div
                        className="ontario-header__search-close-container ontario-columns ontario-small-2 ontario-medium-2">
                        <button
                            className="ontario-header__search-close ontario-header-button ontario-header-button--without-outline"
                            id="ontario-header-search-close"
                            aria-label="{{labels.closeSearch}}">
                            <span aria-hidden="true">close</span>
                            {/*<svg className="ontario-icon"*/}
                            {/*     focusable="false" sol:category="primary" viewBox="0 0 24 24"*/}
                            {/*     preserveAspectRatio="xMidYMid meet">*/}
                            {/*    <use xlink:href="#ontario-icon-close"></use>*/}
                            {/*</svg>*/}
                            <svg className="ontario-icon" focusable="false"
                                 viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                {/*<use xlinkHref="#ontario-icon-close" />*/}
                                <path
                                    d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4z"
                                    fill=""
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </header>

            <nav role="navigation" className="ontario-header-navigation" id="ontario-header-navigation">
                <div className="ontario-header-navigation__banner">
                    <button
                        className="ontario-header-button ontario-header-button--without-outline ontario-header-navigation__close-menu-button"
                        id="ontario-header-navigation-close-toggler" aria-label="close menu">
                        {/*<svg className="ontario-icon" focusable="false" sol:category="primary" viewBox="0 0 24 24"*/}
                        {/*     preserveAspectRatio="xMidYMid meet">*/}
                        {/*    <use xlink:href="#ontario-icon-close"></use>*/}
                        {/*</svg>*/}

                        <svg className="ontario-icon" focusable="false" viewBox="0 0 24 24"
                             preserveAspectRatio="xMidYMid meet">
                            {/*<use xlink:href="#ontario-icon-close"></use>*/}

                            <svg id="ontario-icon-close"><path d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4z" fill=""></path></svg>
                        </svg>
                    </button>
                </div>
                <ul className="ontario-header-navigation__menu-list">
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Arts and culture</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Business and economy</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Driving and roads</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Education and training</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Environment and energy</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Government</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Health and wellness</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Home and community</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Jobs and employment</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Law and safety</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Rural and north</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Taxes and benefits</a>
                    </li>
                    <li className="ontario-header-navigation__menu-item">
                        <a href="/">Travel and recreation</a>
                    </li>
                </ul>
            </nav>

            <div className="ontario-overlay" />
        </>
    );
}

export default Header;
